import ga from '../utils/ga'

export const reportImageCarouselClick = (itemId: number) => {
  ga('send', {
    hitType: 'event',
    eventCategory: 'SearchCatImageCarousel',
    eventAction: 'click',
    eventLabel: `${itemId}`
  })
}
